import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {IToDo} from './todo';
@Injectable({
  providedIn: 'root'
})
export class TodoServiceService {

  constructor(private httpService: HttpClient) { }

  error;
apiUrl: string = 'http://localhost:3000/get';
httpOptions = {
  headers: new HttpHeaders({
    Accept: 'application/json',
    // Authorization: 'ZG1nOmltbmF0MjM5',
  }),
};
  getToDo():Observable<IToDo[]> {
    ///bilgar/assets/todo.json
    return this.httpService.get<IToDo[]>('bilgar/assets/todo.json')
    .pipe(
      tap(_ => this.log('fetched kasse')),
      catchError(this.handleError<IToDo[]>('getToDo', []))
    );
  }

  getKasse2() {
    this.apiUrl='http://localhost:3000/todo';
    return this.httpService.get<IToDo[]>(this.apiUrl, this.httpOptions)
    .pipe(
      tap(_ => this.log('fetched kasse')),
      catchError(this.handleError<IToDo[]>('getKasse', []))
    );
  }


  log(ewe){
    
   console.log(ewe)

  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}

